import { Box, Flex, Image, Stack, Tag, Text, VStack } from "@chakra-ui/react";
import { useMemo } from "react";
import { t } from "i18next";
import { AttributeDefinition, AttributeType } from "@keita/lanepatrol-sdk";
import { AttributeUtils } from "../../../../../../coding/utils/attribute-utils";

interface Props {
  label: string;
  scoreImpact: number;
  attribute: AttributeDefinition;
  value: any;
  valueIsForecasted: boolean;
}
export const AttributeItem: React.FC<Props> = ({
  label,
  scoreImpact,
  attribute,
  value,
  valueIsForecasted,
}) => {
  const printedValue = useMemo(() => {
    if (!value) return value;

    if (attribute.type === AttributeType.Select) {
      return AttributeUtils.getOptionLabel(value);
    }

    return value;
  }, [attribute, value]);

  const image = useMemo(() => {
    if (
      value &&
      attribute.type === AttributeType.Select &&
      attribute.useImageSelection
    ) {
      return (
        <Image
          {...imageProps}
          title={AttributeUtils.getOptionLabel(value)}
          alt={AttributeUtils.getOptionLabel(value)}
          src={AttributeUtils.getImage(attribute, value)}
        />
      );
    } else if (
      attribute.type === AttributeType.Number ||
      (attribute.type === AttributeType.Select && !attribute.useImageSelection)
    ) {
      return (
        <Image
          {...imageProps}
          title={AttributeUtils.getLabel(attribute.name)}
          alt={AttributeUtils.getLabel(attribute.name)}
          src={AttributeUtils.getImage(attribute, value)}
        />
      );
    }

    return null;
  }, [attribute, value]);

  return (
    <Box>
      <Flex alignItems="center">
        <VStack mr={1} gap={0} width="76px" ml={-2} flexShrink={0}>
          {image}
        </VStack>

        <Stack gap={0}>
          <Text fontSize="xs" textTransform="uppercase" fontWeight="bold">
            {label}
          </Text>
          <Text fontSize="sm">{printedValue || "-"}</Text>
          <Text fontSize="xs">
            {`${t("map:attributes.impact")}: `}
            <Box as="span" fontWeight="semibold">
              {scoreImpact}%
            </Box>
          </Text>
          <Box>
            {valueIsForecasted && (
              <Tag.Root my={1} size="sm" colorPalette="primary">
                <Tag.Label>{t("map:attributes.forecastedValue")}</Tag.Label>
              </Tag.Root>
            )}
          </Box>
        </Stack>
      </Flex>
    </Box>
  );
};

const imageProps: any = {
  minWidth: "100%",
  width: "100%",
  mt: -3,
  mb: -1,
  loading: "lazy",
};
